export const DISPLAY_CONTACT_MODAL = 'DISPLAY_CONTACT_MODAL'
export const REMOVE_CONTACT_MODAL = 'REMOVE_CONTACT_MODAL'
export const SEND_CONTACT_INFO = 'SEND_CONTACT_MODAL'
export const VERIFY_LOGIN = 'VERIFY_LOGIN'
export const UPDATE_ACCESS_PERMISSION = 'UPDATE_ACCESS_PERMISSION'